import Core         from '@/core/Core';
import Product      from "@/domains/Products/Product";
import Title_ru_RU  from "@/core/misc/decorators/Title_ru_RU";
import TYPES        from "@/core/services/Changelogs/types";
import Price        from "@/core/types/Price";
import Partner from "@/domains/Partners/Partner";
import Currency from "@/domains/Currencies/Currency";
import BaseEntity from "@/core/misc/BaseEntity";
import serializeSimplified from "@/core/misc/decorators/SerializeSimplified";
import Qty from "@/core/types/Qty";
import DateRange from "@/core/types/DateRange";
import DateSimple from "@/core/types/DateSimple";
import Person from "@/domains/Persons/Person";

class BudgetPrice extends BaseEntity {
	  /** На бэк уходит только id: в реестре номенклатура — родитель записи, и полная сериализация зациклилась бы */
	  @Title_ru_RU('Продукт', TYPES.STRING)
	  @serializeSimplified
	  product: Product;

	  @Title_ru_RU('Цена', TYPES.PRICE)
	  price: Price;

    @Title_ru_RU('Партнер', TYPES.PRICE)
    partner: Partner;

    @Title_ru_RU('Валюта', TYPES.STRING)
    currency: Currency|null;

    @Title_ru_RU('Оптимальный объём закупки', TYPES.NUMBER)
    optimalPurchaseQty: Qty|null;

    /** Правая граница — начало следующей записи, у последней записи открыта */
    @Title_ru_RU('Период действия', TYPES.DATE_RANGE)
    validityPeriod: DateRange;

    private _name: string;

    static fromServer(data: any, result = new BudgetPrice()): BudgetPrice {
      super.fromServer(data, result);

      result.product = Core.utils.hydrate(data.product, Product.fromServer)!;
      result.price = Core.utils.hydrate(data.price, Price.fromServer)!;
      result.partner = Core.utils.hydrate(data.partner, Partner.fromServer)!;
      result.currency = Core.utils.hydrate(data.currency, Currency.fromServer)!;
      result.optimalPurchaseQty = Core.utils.hydrate(data.optimalPurchaseQty, Qty.fromServer);
      result.validityPeriod = Core.utils.hydrate(data.validityPeriod, DateRange.fromServer)!;
      result.createdBy = Core.utils.hydrate(data.createdBy, Person.fromServer);
      result._name = result.product.name;

	  return result;
	  }

    static fromNew(): BudgetPrice {
      const budgetPrice = new BudgetPrice();

      budgetPrice.product = Product.getEmpty();
      budgetPrice.price = Price.fromEmpty();
      budgetPrice.partner = Core.currentPartner;
      budgetPrice._name = budgetPrice.product.name;
      budgetPrice.currency = Core.currentPartner?.country?.localCurrency ?? Core.config.localCurrency;
      budgetPrice.optimalPurchaseQty = null;
      budgetPrice.validityPeriod = new DateRange(DateSimple.today(), null);

      return budgetPrice;
    }

    /** Новая запись по образцу предыдущей: те же условия, дата начала — сегодня */
    static fromPrevious(previous: BudgetPrice): BudgetPrice {
      const budgetPrice = BudgetPrice.fromNew();

      budgetPrice.product = previous.product;
      budgetPrice.price = previous.price;
      budgetPrice.currency = previous.currency;
      budgetPrice.optimalPurchaseQty = previous.optimalPurchaseQty;
      budgetPrice._name = previous.product.name;

      return budgetPrice;
    }

    get name(): string {
      return this._name;
    }

    set name(value: string) {
      this._name = value;
    }

    toString() {
      return this.product?.name ? 'Бюджетная цена: ' + this.product?.name : 'Бюджетная цена';
    }
}

export default BudgetPrice;
